module.exports = __webpack_public_path__ + "static/media/love_icon.fe903f5d.svg";